var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"editor",staticClass:"plain-editor",class:{
    focus: _vm.isFocus && !_vm.disabled,
    'is-invalid': _vm.state === false,
    'is-valid': _vm.state === true,
    disabled: _vm.disabled,
  },attrs:{"value":_vm.value,"options":_vm.editorOptions},on:{"change":function($event){return _vm.$emit('change', $event)},"input":function($event){return _vm.$emit('input', $event)},"blur":_vm.handleBlur,"focus":_vm.handleFocus}})}
var staticRenderFns = []

export { render, staticRenderFns }